import { HANDOFF_PAYLOAD_STORAGE_KEY } from '../constants/investor-entry.constants';
import { parseHandoffPayload } from '../utils/parse-handoff-payload';

import { logger } from '@/lib/logger';
import { createTabStorage } from '@/shared/tab-storage/public';

// Stored raw: the blob is already a string, and JSON-encoding it would change what sits under the
// key for anything else that reads it.
const payloadStorage = createTabStorage<string>(HANDOFF_PAYLOAD_STORAGE_KEY, {
  serialize: (value) => value,
  deserialize: (raw) => raw,
});

/**
 * The blob rides in the fragment so it never reaches server logs or Referer; stripping it on
 * read keeps it out of history too. Persisting it costs nothing extra — the handoff link is
 * reusable by design — and without it a refresh strands the investor. Idempotent.
 */
export const captureHandoffPayload = (): string | null => {
  const fromHash = parseHandoffPayload(window.location.hash);

  if (fromHash) {
    payloadStorage.write(fromHash);
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
  }

  const payload = fromHash ?? payloadStorage.read();

  logger.info('handoff payload read', { hasPayload: !!payload, isFromHash: !!fromHash });

  return payload;
};

export const getHandoffPayload = (): string | null => payloadStorage.read();
